import { MUTATION_REQUEST_VEHICLE, SchemaTypes } from '@allesauto/graphql';
import { ApolloError, useMutation } from '@apollo/client';

import { useAuthorizationHeader } from '@/global/hooks/useAuthorizationHeader';

export const useRequestVehicleMutation = (): {
  requestVehicle: (
    sku: string,
    dealerId: string,
    formData: SchemaTypes.RequestVehicleInput,
    configuratorId?: string
  ) => Promise<any>;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const authorizationHeader = useAuthorizationHeader();

  const [mutationRequestVehicle, { loading, error }] = useMutation(
    MUTATION_REQUEST_VEHICLE,
    {
      context: authorizationHeader,
    }
  );

  return {
    requestVehicle: async (vehicleId, dealerId, formData, configuratorId) => {
      const { data } = await mutationRequestVehicle({
        variables: {
          sku: vehicleId,
          dealerId,
          formData,
          configuratorId,
        },
      });
      return data;
    },
    loading,
    error,
  };
};
